import { EmailOtpType } from "@supabase/supabase-js";
import { CobriefUserMetadata } from "../functions/api/types/hono";

export interface ILoginRequest {
  email: string;
  password: string;
}

export type SocialProvider = 'google' | 'linkedin_oidc';

export interface IProviderLoginRequest {
  provider: SocialProvider;
}

export interface IForgotPassword {
  email: string;
}

export interface IResetPassword {
  password: string;
  confirmPassword: string;
}

export interface IConfirmRequest {
  tokenHash: string;
  type: EmailOtpType;
  next?: string;
}

export interface ISignupRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface ISignupRequestHoneypot extends ISignupRequest {
  name: string;
}

export interface IConfirmResponse {
  user: UserData;
  session: SessionData;
  type?: EmailOtpType;
  next?: string;
}

export interface SessionData {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  expires_at: number;
}

export interface UserData {
  id: string;
  email: string;
  profile: ProfileData;
}

export interface ProfileData {
  first_name: string;
  last_name: string;
  is_superuser?: boolean;
  skip_onboarding?: boolean;
  subscriptions?: SubscriptionData;
}

export interface SubscriptionData {
  id: string;
  prices: Prices;
  status: SubscriptionStatus;
  created: string;
  user_id: string;
  ended_at: any;
  metadata: any;
  price_id: string;
  quantity: number;
  cancel_at: any;
  trial_end: any;
  canceled_at: any;
  trial_start: any;
  current_period_end: string;
  cancel_at_period_end: boolean;
  current_period_start: string;
}

export enum SubscriptionStatus {
  Incomplete = "incomplete",
  IncompleteExpired = "incomplete_expired",
  Trialing = "trialing",
  Active = "active",
  PastDue = "past_due",
  Canceled = "canceled",
  Unpaid = "unpaid",
  Paused = "paused"
}

export interface Prices {
  id: string;
  type: string;
  active: boolean;
  currency: string;
  interval: string;
  metadata: any;
  products: Products;
  product_id: string;
  description: any;
  unit_amount: number;
  interval_count: number;
  trial_period_days: number;
}

export interface Products {
  id: string;
  name: string;
  image: any;
  active: boolean;
  metadata: any;
  description: string;
}

export interface JwtPayload {
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  sub: string;
  email: string;
  phone: string;
  app_metadata: AppMetadata;
  user_metadata: CobriefUserMetadata;
  role: string;
  aal: string;
  amr: Amr[];
  session_id: string;
}

export interface AppMetadata {
  provider: string;
  providers: string[];
}

export interface Amr {
  method: string;
  timestamp: number;
}
